import { MCP_TOOL_GROUPS_IN_USE } from "@esi/shared";
import { mcpToolGroupCopy } from "../admin/settings-groups.ts";

/**
 * `settings.behaviour.keys.<copy>` per key: one wording for project and backoffice rows. Plain
 * data, no React: the product help generator (`packages/help`) reads it too.
 */
export const SETTING_COPY: Readonly<Record<string, string>> = {
  "tools.webSearch": "webSearch",
  "tools.webSearch.provider": "webProvider",
  "tools.webSearch.domains": "webDomains",
  "tools.webSearch.maxAgeDays": "webMaxAge",
  "tools.webFetch": "webFetch",
  "tools.webFetch.provider": "webFetchProvider",
  "tools.webFetch.approval": "webFetchApproval",
  "tools.webFetch.domains": "webFetchDomains",
  "tools.codeExecution": "codeExecution",
  "tools.codeExecution.provider": "codeExecutionProvider",
  "tools.codeExecution.egress": "codeEgress",
  "tools.egress": "egress",
  "models.allowed": "modelsAllowed",
  // `models.allowedModels` is edited on the Models screen (Advanced), with its coverage check.
  "models.advancedPicker": "advancedPicker",
  "models.defaultEffort": "defaultEffort",
  "models.turnMaxUsd": "turnMaxUsd",
  "models.sharePressureThresholdPct": "sharePressureThresholdPct",
  "models.residency": "residency",
  "projects.tasks": "tasks",
  "projects.allowPersonal": "allowPersonal",
  "projects.shareOutsideEntity": "shareOutsideEntity",
  "knowledge.maxUploadMb": "maxUploadMb",
  "knowledge.classificationScheme": "classificationScheme",
  "knowledge.defaultClassification": "defaultClassification",
  "knowledge.ocr": "ocr",
  "knowledge.imageCaptions": "imageCaptions",
  "knowledge.ocrMaxPages": "ocrMaxPages",
  "knowledge.ocrMonthlyPages": "ocrMonthlyPages",
  "knowledge.declassification": "declassification",
  "knowledge.generatedSources": "generatedSources",
  "answers.sourcesOnly": "sourcesOnly",
  "conversations.standalone": "standalone",
  "conversations.artefacts": "artefacts",
  "conversations.thinkingSummary": "thinkingSummary",
  "conversations.attachments": "attachments",
  "memory.personal": "memoryPersonal",
  "memory.project": "memoryProject",
  "memory.retentionDays": "memoryRetention",
  "wiki.guidelines": "guidelines",
  "wiki.placement": "placement",
  "wiki.reviewAfterDays": "reviewAfterDays",
  "wiki.autoDraftSummaries": "autoDraftSummaries",
  "wiki.suggestions": "wikiSuggestions",
  "wiki.trust": "wikiTrust",
  "auth.mfa": "mfa",
  "auth.nativeClients": "nativeClients",
  "auth.jitProvisioning": "jitProvisioning",
  "auth.deviceGrant": "deviceGrant",
  "telemetry.clientEvents": "clientTelemetry",
  "feedback.enabled": "feedbackEnabled",
  "feedback.agentSuggestions": "feedbackAgentSuggestions",
  "feedback.assistedTriage": "assistedTriage",
  "mcp.enabled": "mcpEnabled",
  "mcp.writeTools": "mcpWriteTools",
  "wiki.mcpSelfPublish": "mcpSelfPublish",
  "mcp.classificationCeiling": "mcpCeiling",
  ...Object.fromEntries(MCP_TOOL_GROUPS_IN_USE.map((g) => [`mcp.tools.${g}`, mcpToolGroupCopy(g)])),
  "directory.idpGroupsMaxAge": "idpGroupsMaxAge",
};
